export const environment = {
  production: false,
  apiBaseUrl: 'https://rknsz40w30.execute-api.ap-south-1.amazonaws.com/dev'
};
